// extracted by mini-css-extract-plugin
module.exports = {"container":"IppicaNavContentEmpty_container__9Sjfe","icon":"IppicaNavContentEmpty_icon___GOHk","text":"IppicaNavContentEmpty_text__aAnMi"};